<template>
  <div class="list-editor-more">
    <div class="header">
      <span class="name" :class="{ 'has-text-danger': hidden }">{{
        list.name
      }}</span>
      <!-- <label class="radio" style="margin-left: 16px">
        <input type="checkbox" name="hidden" :value="true" v-model="hidden" />
        Hidden
      </label> -->
      <!-- <span class="link has-text-warning is-pulled-right" @click="close"
        >Close</span
      > -->
    </div>
    <button class="delete" @click="close" />

    <div class="setting">
      <label class="radio">
        <input type="checkbox" name="hidden" :value="true" v-model="hidden" />
        Hidden
      </label>
    </div>

    <!-- <div class="setting">
      <label class="radio">
        <input
          type="checkbox"
          name="randomise"
          :value="true"
          v-model="randomise"
        />
        Randomise list order
      </label>
    </div> -->

    <div class="setting has-text-right">
      <span class="link has-text-danger" @click="deleteList"
        ><i class="far fa-trash-alt fa-sm" />&nbsp;Delete</span
      >
    </div>
  </div>
</template>


<script>
export default {
  name: "ListEditorMore",
  props: {
    list: Object, // list_title blob
  },
  data() {
    return {
      hidden: false,
    };
  },
  mounted() {
    console.log("list", this.list);
    if (!this.list) return; // will be null if List Title not yet created (not required)
    // var o = this.blob.data.settings;
    // if (!o) return;
    this.hidden = this.list.hidden;
  },
  methods: {
    deleteList() {
      this.$emit("delete", this.list);
      this.close();
    },
    close() {
      this.save();
      this.$emit("close");
    },
    save() {
      var options = {
        hidden: this.hidden,
      };
      this.$emit("save", options);
    },
  },
};
</script>

<style scoped>
.list-editor-more {
  position: absolute;
  bottom: 0;
  padding: 10px;
  padding-bottom: 20px;
  width: 100vw;
  /* height: 100vh; */
  background-color: #333;
  text-align: left;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.233);
  color: white;
}
.header {
  margin-bottom: 10px;
  padding: 0 6px;
  color: white;
}
.setting {
  padding: 8px;
}
.name {
  font-size: 1.3em;
  font-weight: 500;
}
.delete {
  position: absolute;
  right: 0;
  top: 0;
  padding: 20px;
  margin: 10px;
}
</style>